import { createFileRoute } from '@tanstack/react-router';
import { DetailsTab } from '@/features/supply-points/components/settings-details-tab/DetailsTab';
import { DetailsTabSkeleton } from '@/common/components/loading-skeleton/DetailsTabSkeleton';
import { useSupplyPoint } from '@/features/supply-points/context/useSupplyPoint';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/settings/details')({
  component: RouteComponent,
  pendingComponent: DetailsTabSkeleton,
});

function RouteComponent() {
  const { activeSupplyPoint } = useSupplyPoint();
  return <DetailsTab key={activeSupplyPoint?.id} />;
}
